import emitter from "tiny-emitter/instance";
const artist = {
  methods: {
    openArtistProfileDrawer(uuid) {
      emitter.emit("openArtistProfileDrawer", uuid);
    },
  },
};
export { artist };
